import React, { memo } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { validators } from 'investira.sdk';
import {
  Container,
  Card,
  Stack,
  TextField,
  Button,
  LoadingButton,
  Icon
} from 'investira.react.components';
import { VALIDATIONS } from '../../../const';
import { PageTemplate } from '../../../components/templates';
import { usePortfoliosContext } from '../../../contexts/PortfolioContext';
import PorfolioCarteiraSearch from '../_components/PorfolioCarteiraSearch';

const PortfoliosAdd = memo(() => {
  const { state, actions } = usePortfoliosContext();
  const navigate = useNavigate();

  const VALIDATION_SCHEMA = Yup.object().shape({
    portfolio: Yup.string().max(128, 'Máximo de 128 caracteres').required(VALIDATIONS.REQUIRED),
    carteiras: Yup.array().required(VALIDATIONS.REQUIRED)
  });

  const formik = useFormik({
    initialValues: { portfolio: '', carteiras: [] },
    validationSchema: VALIDATION_SCHEMA,
    validateOnMount: false,
    onSubmit: (pValues, pActions) => {
      const { portfolio, carteiras } = pValues;
      const xCarteirasId = carteiras.map(xCarteira => xCarteira.carteira_id).join(', ');

      actions.createPortfolio(
        {
          portfolio,
          carteira_id: xCarteirasId
        },
        rRes => {
          navigate('/portfolios');
        },
        rErr => {
          console.log(rErr);
        },
        () => {
          pActions.setSubmitting(false);
        }
      );
    }
  });

  console.log(formik.values);

  // handleChange para carteiras
  const handleCarteirasChange = pEventOrValues => {
    // Caso o componente filho envie o array direto como valor
    if (Array.isArray(pEventOrValues)) {
      formik.setFieldValue('carteiras', pEventOrValues);
    }
    // Caso envie um evento do tipo padrão (event)
    else if (
      pEventOrValues &&
      pEventOrValues.target &&
      pEventOrValues.target.name === 'carteiras'
    ) {
      formik.setFieldValue('carteiras', pEventOrValues.target.value);
    }
  };

  return (
    <PageTemplate title="Novo Portfolio" maxWidth="md">
      <form noValidate onSubmit={formik.handleSubmit} autoComplete="off">
        <Card>
          <Stack flexGrow={1} px={3} py={3} gap={2}>
            <Stack>
              <TextField
                id="portfolio"
                name="portfolio"
                label="Portfólio"
                value={formik.values.portfolio}
                onChange={formik.handleChange}
                placeholder="Digite um nome para o portfólio"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                error={Boolean(formik.errors.portfolio)}
                helperText={formik.errors.portfolio}
                disabled={formik.isSubmitting}
              />
            </Stack>
            <Stack>
              <PorfolioCarteiraSearch
                value={formik.values.carteiras}
                onChange={handleCarteirasChange}
              />
            </Stack>

            <Stack
              flex={1}
              direction="row"
              justifyContent="flex-end"
              //sx={{ pb: 2 }}
              spacing={2}>
              <Button variant="outlined" type="button" color="primary" onClick={() => navigate(-1)}>
                Cancelar
              </Button>
              <LoadingButton
                startIcon={<Icon iconName="save" size={16} />}
                variant="contained"
                type="submit"
                loading={formik.isSubmitting}
                disabled={
                  validators.isEmpty(formik.values.carteiras) ||
                  formik.isSubmitting ||
                  !formik.isValid
                }>
                Salvar
              </LoadingButton>
            </Stack>
          </Stack>
        </Card>
      </form>
    </PageTemplate>
  );
});

PortfoliosAdd.displayName = 'PortfoliosAdd';

export default PortfoliosAdd;
